import { ShareAltOutlined } from "@ant-design/icons";
import { Modal, Typography } from "antd";
import { FC, useState } from "react";
import SharedAdvert from "./SharedAdvert";
import { useSearchParams } from "react-router-dom";

const ShareButton:FC<{advert?:any}> = ({advert}) => {
  const { Text } = Typography;
  const [isShowSharedAdvertModal, setIsShowSharedAdvertModal] = useState(false);
  const [searchParams] = useSearchParams()
  const advertId = searchParams.get("id")

  return (
    <>
      <span className="hover:cursor-pointer !flex gap-1 !p-2  !rounded-md transition" onClick={()=>{setIsShowSharedAdvertModal(true)}}  >
        <ShareAltOutlined className="!text-xs !text-red-500" />
        <Text className="!text-xs" >Paylaş</Text>
      </span>
      <Modal
        open={isShowSharedAdvertModal}
        onCancel={() => {
          setIsShowSharedAdvertModal(false);
        }}
        footer={false}
        title={"İlanı Paylaş"}
      >
        <SharedAdvert advert={advertId?{id:advertId}:advert}  />
      </Modal>
    </>
  );
};

export default ShareButton;
